import React, { FormEvent, useState } from 'react';
import { useRouter } from 'next/router';

import { ILearningCenterSearchBarFields } from '@/types/contentful';

import { SearchInput } from './SearchInput';
import { FilterToggle } from './FilterToggle';
import { Filters } from './Filters';
import { SearchFilters, DEFAULT_FILTERS } from './shared';

interface SearchBarProps {
  filters: ILearningCenterSearchBarFields;
}

export function SearchBar({ filters }: SearchBarProps) {
  const router = useRouter();
  const searchState = router?.query?.subject ?? '';
  const [searchValue, setSearchValue] = useState(searchState.toString());
  const [selectedFilters, setSelectedFilters] =
    useState<SearchFilters>(DEFAULT_FILTERS);
  const [filtersOpen, setFiltersOpen] = useState(true);

  const handleCancel = () => {
    setFiltersOpen(false);
    setSearchValue('');
  };

  const handleFormSubmit = (event: FormEvent) => {
    event.preventDefault();
  };

  const search = (
    value: string,
    searchFilters: ILearningCenterSearchBarFields | SearchFilters
  ) => {
    const hasFilters = Object.values(searchFilters).some(
      (filter) => filter.length > 0
    );

    if (value === '' && !hasFilters) {
      return;
    }

    const searchParams = new URLSearchParams();
    searchParams.append('subject', searchValue);

    for (const [filterName, filterValues] of Object.entries(searchFilters)) {
      if (filterValues.length > 0) {
        searchParams.append(filterName, filterValues);
      }
    }

    window.location.href = `/learning-center/search?${searchParams}`;
  };

  return (
    <form
      method="GET"
      className="z-[1] h-min w-full rounded-[2.8rem] bg-white !p-4 shadow-dropdown"
      onSubmit={handleFormSubmit}
    >
      <div className="flex h-14">
        <FilterToggle
          open={filtersOpen}
          onClick={(open) => setFiltersOpen(open)}
        />
        <SearchInput
          value={searchValue}
          hideSubmitButton={filtersOpen}
          onChange={setSearchValue}
          onSubmit={() => search(searchValue, selectedFilters)}
        />
      </div>
      <Filters
        filters={filters}
        open={filtersOpen}
        onCancel={handleCancel}
        onChange={setSelectedFilters}
        onSubmit={() => search(searchValue, selectedFilters)}
      />
    </form>
  );
}
